module.exports = __webpack_public_path__ + "img/load.90b177e6.gif";